<template>
    <div class="modal fade" id="authModal" ref="authModal" tabindex="-1" aria-labelledby="authModal" aria-hidden="true">
        <div
            class="modal-dialog modal-dialog-centered tablet:!w-[500px] !mx-2.5 tablet:!mx-[unset] !static tablet:!absolute !right-4 !top-0 !m-0 h-full">
            <div class="modal-content">
                <div class="modal-body !p-2.5 !pb-[30px]">
                    <div
                        class="relative rounded-[10px] p-[12px] flex items-center mobile:h-[65px] largeDesktop:h-[80px] bg-customBlue-100">
                        <button type="button"
                            class="absolute top-3 right-[10px] w-6 h-6 z-50 focus:!outline-none focus:!shadow-none"
                            data-bs-dismiss="modal" aria-label="Close">
                            <img src="../../assets/images/modal-cross-icon.svg" alt="Cross Icon"
                                class="w-[30px] h-[30px] object-contain">
                        </button>
                        <div class="flex items-center gap-[5px] largeDesktop:gap-[10px]">
                            
                            <div class="leading-[1] text-white">
                                <h4 class="text-[20px] laptop:text-[24px] m-0 font-poppins font-semibold">{{ state == 1 ? 'Sign in' : state == 2 ? 'Verification' : 'Register Now' }}
                                </h4>
                            </div>
                        </div>
                    </div>
                    <div class="relative px-[5px] laptop:px-2.5">
                        <loginComponent v-if="state == 1" :callbacks="handleCallback" mode="modal"/>
                        <verificationComponent v-else-if="state == 2" :callbacks="handleCallback" mode="modal"/>
                        <registerComponent v-else-if="state == 3" :callbacks="handleCallback" mode="modal"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Modal } from "bootstrap";
import loginComponent from "./loginComponent.vue";
import verificationComponent from "./verificationComponent.vue";
import registerComponent from "./registerComponent.vue";

export default {
    props: ["callbacks"],
    data() {
        return {
            state: 1
        };
    },

    components: {
        loginComponent,
        verificationComponent,
        registerComponent
    },

    computed: {


    },
    watch: {

    },

    mounted() {

    },

    unmounted() {
        document.documentElement.classList.remove("overflow-hidden");
        this.modal = null
    },

    methods: {
        openModal() {
            this.state = 1
            const modalEl = this.$refs.authModal;
            // Create bootstrap modal
            this.modal = new Modal(modalEl, { backdrop: 'static' });
            document.documentElement.style.overflow = 'hidden';
            this.adjustPlanModalHeight();
            window.addEventListener('resize', this.adjustPlanModalHeight);
            window.addEventListener('orientationchange', this.adjustPlanModalHeight);
            // Fix scroll restore on close
            modalEl.addEventListener("hidden.bs.modal", () => {
                document.documentElement.classList.remove("overflow-hidden");
                document.documentElement.style.overflow = '';
                this.modal = null
                window.addEventListener('resize', this.adjustPlanModalHeight);
                window.addEventListener('orientationchange', this.adjustPlanModalHeight);
            });

            modalEl.addEventListener("shown.bs.modal", () => {
                if (this.$refs.scrollBox) {
                    this.$refs.scrollBox.scrollTo({ top: 0, behavior: "smooth" });
                }
            });
            this.modal.show();
        },

        closeModal() {
            // Tailwind way → enable scroll
            if (window.innerWidth > 992) {
                document.documentElement.classList.remove("overflow-hidden");
            }
            if (this.modal) {
                this.modal.hide();
            }
        },

        adjustPlanModalHeight() {
            const modalContent = this.$refs.scrollBox;
            if (modalContent) {
                const vh = window.innerHeight;
                const vw = window.innerWidth;
                let maxHeight;
                if (vw < 300) {
                    maxHeight = vh * 0.6 - 40;
                } else if (vw < 768) {
                    maxHeight = vh * 0.6 - 50;
                } else if (vw < 991) {
                    maxHeight = vh * 0.6 - 50;
                } else if (vw < 1440) {
                    maxHeight = vh * 0.6 - 30;
                }
                else {
                    maxHeight = vh * 0.7 - 100;
                }
                modalContent.style.maxHeight = `${maxHeight}px`;
                modalContent.style.overflowY = 'auto';
            }
        },

        handleCallback(option) {
            if (option == "verification") {
                this.state = 2
            } else if (option == "register") {
                this.state = 3
            } else if (option == "back" || option == "login") {
                this.state = 1
            } else if (option == "verified") {
                if (this.callbacks){
                    this.callbacks(option)
                }
            }
        }
    },
};
</script>


